import { data } from "../data/data"

class Flags {
	_allFlags = data;
	_randomFlags = [];
	_options = [];

	getRandomFlags = () => {
		this._randomFlags = [];
		for (let i = 0; i < 10; i++) {
			this._randomFlags.push(
				this._allFlags[Math.floor(Math.random() * this._allFlags.length)]
			);
		}
		return this._randomFlags;
	};

	getRandomOptions = (currentFlagIndex) => {
		this._options = [];
		while (this._options.length < 6) {
			// let flagName =
			// if (!this._options.includes(flagName) === false && ) { }
			this._options.push(
				this._allFlags[Math.floor(Math.random() * this._allFlags.length)]?.name.common
			);
		}

		// put the original answer's index in the optionIndex array
		this._options.splice(
			Math.floor(Math.random() * 7),
			0,
			this._randomFlags[currentFlagIndex]?.name.common
		);

		let correctOption = this._randomFlags[currentFlagIndex]?.name.common;

		return [this._options, correctOption];
	};
}

export default Flags;
